import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import * as styles from './AuthenticateMotivation.css';
import { AuthenticateMotivationIcon } from './AuthenticateMotivationIcon';
import { Link } from '../../Link';

export interface IAuthenticateMotivationProps {
  url: string;
  onAuthLinkClick(): void;
}

export function AuthenticateMotivation({ url, onAuthLinkClick }: IAuthenticateMotivationProps) {
  return (
    <div className={styles['authenticate_motivation']}>
      <div className={styles['authenticate_motivation-icon']}>
        <AuthenticateMotivationIcon />
      </div>
      <p className={styles['authenticate_motivation-title']}>
        Жилой комплекс добавлен <Link url="/favorites/">в избранное</Link>
      </p>
      <p className={styles['authenticate_motivation-text']}>
        Авторизуйтесь, чтобы получить доступ к избранному с любого устройства
      </p>
      <div className={styles['authenticate_motivation-button']}>
        <LinkButton href={`/authenticate/${url}`} theme="fill_secondary" size="XS" onClick={onAuthLinkClick}>
          Авторизоваться
        </LinkButton>
      </div>
    </div>
  );
}
